"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatadogErrorBoundary = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireDefault(require("react"));
var _browserRum = require("@datadog/browser-rum");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DatadogErrorBoundary = exports.DatadogErrorBoundary = /*#__PURE__*/function (_React$Component) {
  function DatadogErrorBoundary() {
    (0, _classCallCheck2["default"])(this, DatadogErrorBoundary);
    return _callSuper(this, DatadogErrorBoundary, arguments);
  }
  (0, _inherits2["default"])(DatadogErrorBoundary, _React$Component);
  return (0, _createClass2["default"])(DatadogErrorBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(err, info) {
      _browserRum.datadogRum.addError(err, {
        extra: info
      });
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);
}(_react["default"].Component);